import { DO_LOGIN, DO_LOGOUT, RESEND_OTP, VERIFY_OTP } from '../actionTypes';

const initialState = {
  isLoggedIn: false,
  cred: [],
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case DO_LOGIN:
      return {
        ...state,
        cred: action.payload,
      };
    case DO_LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    case VERIFY_OTP:
      return {
        ...state,
        isLoggedIn: true,
      };
    case RESEND_OTP:
      return {
        ...state,
        cred: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default loginReducer;
